/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kommentarbut2Inputs */

const de__field_kommentarbut2 = /** @type {(inputs: _Field_Kommentarbut2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar BuT`)
};

/**

* @param {_Field_Kommentarbut2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kommentarbut2 = /** @type {((inputs?: _Field_Kommentarbut2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kommentarbut2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kommentarbut2(inputs)
});
export { _field_kommentarbut2 as "_field_kommentarBuT" }